import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getAllDebtorSpecificationsbyDebtorIdAsync } from '@application/features/debtors/debtorThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
const RepairInstructionTable = ({ onRowClick, isRepairInstructionsTabBold }) => {
    const { id } = useParams();
    const dispatch = useAppDispatch();
    const { debtorSpecifications } = useAppSelector((state) => state.debtors);
    useEffect(() => {
        if (id) {
            dispatch(getAllDebtorSpecificationsbyDebtorIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                if (isRepairInstructionsTabBold && res.length > 0) {
                    isRepairInstructionsTabBold(true);
                }
                else {
                    isRepairInstructionsTabBold && isRepairInstructionsTabBold(false);
                }
            });
        }
    }, [id]);
    const handleRowClick = (id) => {
        onRowClick(id);
    };
    return (_jsx(_Fragment, { children: _jsx("div", { className: 'custom-table-container', children: _jsx("div", { className: 'vn-table-container', children: _jsx("div", { className: 'vn-main', children: _jsxs("table", { className: 'table', children: [_jsx("thead", { className: 'vn-table-thead', children: _jsxs("tr", { className: 'vn-custom-grid-header-card', children: [_jsx("th", {}), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Trefwoorden" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Voorschrift" }) })] }) }), _jsx("tbody", { className: 'vn-table-tbody', children: id &&
                                    debtorSpecifications &&
                                    debtorSpecifications.map((debtorSpecification) => {
                                        return (_jsxs("tr", { style: { cursor: 'pointer' }, onClick: (e) => {
                                                handleRowClick(debtorSpecification.id);
                                            }, children: [_jsx("td", {}), _jsx("td", { children: _jsx("span", { children: debtorSpecification.keywords }) }), _jsx("td", { children: _jsx("span", { children: debtorSpecification.specification }) })] }, debtorSpecification.id));
                                    }) })] }) }) }) }) }));
};
export default RepairInstructionTable;
